<ft-modal-editor-wrapper>
    <ng-template #triggerTmpl>
        <ng-content></ng-content>
    </ng-template>
    <div class="ft2-exclude-editor" #excludeEditor [style]="{'min-width': setMinWidth(excludeEditor)}">
        <div class="ft2-exclude-editor_col">
            <p class="solid-text medium-text mb-1">{{ leftLabel }}</p>
            <div class="ft2-exclude-editor_lists-wrapper">
                <ng-container *ngIf="groups?.length">
                    <ng-container *ngFor="let group of groups">
                        <ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{ items: leftSideGroupItems(group), left: true, label: group.label }"></ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!groups?.length" [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{ items: leftSideItems, left: true }"></ng-container>
                <ng-container *ngIf="!leftSideItems?.length && searchCriteria" [ngTemplateOutlet]="noResults"></ng-container>
            </div>
        </div>
        <div class="ft2-exclude-editor_col">
            <p class="solid-text medium-text mb-1">{{ rightLabel }}</p>
            <div class="ft2-exclude-editor_lists-wrapper">
                <ng-container *ngIf="groups?.length">
                    <ng-container *ngFor="let group of groups">
                        <ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{ items: rightSideGroupItems(group), right: true, label: group.label }"></ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!groups?.length" [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{ items: rightSideItems, right: true }"></ng-container>
                <ng-container *ngIf="!rightSideItems?.length && searchCriteria" [ngTemplateOutlet]="noResults"></ng-container>
            </div>
        </div>
        <div class="ft2-input-wrapper full-width">
            <mat-icon class="ft2-input-icon icon-sm text-gray-400 ml-2" svgIcon="search"></mat-icon>
            <input class="ft2-exclude-editor_search ft2-input -large"
                   [(ngModel)]="searchCriteria"
                   [placeholder]="placeholder"
                   type="text">
        </div>
    </div>

    <div *ngIf="customControls" class="ft2-edit-dialog_footer-control mr-3">
        <ng-content select=".ft2-exclude-editor_dialog-footer-control"></ng-content>
    </div>
</ft-modal-editor-wrapper>

<ng-template #list let-items="items" let-left="left" let-right="right" let-label="label">
    <ng-container *ngIf="items?.length">
        <p *ngIf="label" class="solid-text small-text ft2-exclude-editor_list-label" [class.ml-4]="right">
            {{ label }}
        </p>
        <ul class="ft2-exclude-editor_list">
            <li class="ft2-exclude-editor-item" *ngFor="let item of items" (click)="toggleFlag(item)">
                <mat-icon *ngIf="right"
                          class="ft2-exclude-editor-item_icon text-gray-400 icon-xs mr-2"
                          svgIcon="arrow-left"></mat-icon>
                <div class="full-width">
                    {{ item[bindLabel] }}
                    <ng-container *ngIf="bindCount && (item[bindCount] || item[bindCount] == 0)">({{ item[bindCount] }})</ng-container>
                    <br>
                    <small *ngIf="item[bindSubLabel]">
                        {{ item[bindSubLabel] }}
                    </small>
                </div>
                <mat-icon *ngIf="left"
                          class="ft2-exclude-editor-item_icon text-gray-400 icon-xs ml-auto"
                          svgIcon="arrow-right"></mat-icon>
            </li>
        </ul>
    </ng-container>
</ng-template>

<ng-template #noResults>
    <ul class="ft2-exclude-editor_list">
        <li class="text-muted ft2-exclude-editor-item -disabled">
            No search results
        </li>
    </ul>
</ng-template>
